import type { AddressByZipCode } from '~/domain/Assegurou/addressByZipcode';
import type { AddressByZipcodeResponseDTO } from '~/dto/Assegurou/addressByZipcode';

export const adrressByZipcodeDTOToAdressByZipcode = ({
  success,
  resultData,
}: AddressByZipcodeResponseDTO): AddressByZipCode => {
  if (success && resultData[0]) {
    const resultAddress = resultData[0];

    return {
      success,
      address: {
        neighborhood: resultAddress.bairro,
        city: resultAddress.cidade,
        state: resultAddress.uf,
        street: resultAddress.logradouro,
      },
    };
  }
  return { success: false };
};
